"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var deepmerge_1 = __importDefault(require("deepmerge"));
exports.textTheme = function (theme) {
    var componentTheme = {
        lineHeight: {
            large: '1.25rem',
            medium: '1.125rem',
            small: '0.875rem',
        },
        fontSize: {
            large: '0.9375rem',
            medium: '0.8125rem',
            small: '0.6875rem',
        },
        margin: {
            large: '1.5rem',
            small: '.5rem',
        },
    };
    if (theme.component.text) {
        componentTheme = deepmerge_1.default(componentTheme, theme.component.text);
    }
    return __assign(__assign({}, theme), { component: __assign(__assign({}, theme.component), { text: componentTheme }) });
};
exports.default = exports.textTheme;
//# sourceMappingURL=theme.js.map